export default () => ({
  includes: ['degree'],
  entity: 'dependent',
  entities: 'dependents',
  dependents: [],
  isEdited: false,
  dependent: {
    id: null,
    user_id: null,
    covenant_id: null,
    kinship_id: null,
    name: null,
    birthdate: null,
    email: null,
    phone: null,
    mobile: null
  },
  date: new Date(),
  config: {
    locale: 'pt-br',
    format: 'DD/MM/YYYY',
    useCurrent: false,
    widgetPositioning: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  }
  // removido para não direcionar para listagem
  // prefixRouter: 'settings.dependents'
})



// WEBPACK FOOTER //
// ./src/app/settings/dependents/resources/data.js